import * as React from 'react'

import { Text, TextName } from 'sdk'
import { DottedBackgroundCard } from 'components/dotted-background-card/DottedBackgroundCard'
import { TechBenefitsCard } from 'pages/home-page/components/tech-benefits-card/TechBenefitsCard'
import ArrowIcon from 'pages/home-page/components/tech-benefits-card/assets/arrow.svg'

import type { ResourcesGpuAccelerationCmsContent } from 'core/services/cms/interfaces'

import classes from './GPUAccelerationSection.module.scss'

interface GPUAccelerationSectionProps {
  content: ResourcesGpuAccelerationCmsContent
}

export const GPUAccelerationSection: React.FC<GPUAccelerationSectionProps> = ({ content }) => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2}>{content.title}</Text>

      <DottedBackgroundCard className={classes.descriptionCard}>
        <Text type={TextName.Text}>
          {content.body}
        </Text>
      </DottedBackgroundCard>

      <div className={classes.cardsGrid}>
        {content.cards.map((card) => (
          <TechBenefitsCard
            key={card.title}
            title={card.title}
            body={card.body}
            iconSrc={ArrowIcon}
          />
        ))}
      </div>
    </div>
  )
}
